<span [ngStyle]="{ width: 'auto', height: size + 'px', 'border-radius': circle ? size / 2 + 'px' : 0 + 'px' }"
    [ngClass]="enabled ? 'user-pic-enabled' : 'user-pic-disabled'">
    <img [ngStyle]="{'background-color': Organization.imageBackgroundColor && imagePath ? Organization.imageBackgroundColor : ''}"
        *ngIf="imagePath" alt="image" [src]="imagePath | imagePath" [height]="size">

</span>
